import ScrollSection from 'components/ScrollSection';
import UserProfileForm from './UserProfileForm';

const UserProfile = () => {
  return (
    <ScrollSection>
      <UserProfileForm />
    </ScrollSection>
  );
};

export default UserProfile;
